import { hashSeed } from '../../effects/atmosphere/atmospherePlacement';
import type { PlatformAccentBounds } from '../organicPlatformAccent';
import { drawHarborMaterial, type HarborMaterialStyle } from '../materials/harborMaterials';
import { drawTownQuay, drawTownTimber, validTownSurface, type TownMaterialGraphics } from '../materials/townSurfaceMaterials';

const QUAY = {
  face: 0x374457, deep: 0x222b3b, mortar: 0x252d3e,
  stones: [0x4a566a, 0x424d61, 0x39465a, 0x525c6d],
  cap: 0x737d8f, edge: 0xa5aabd, wet: 0x334956,
} as const;
const TIMBER = {
  face: 0x57443f, shade: 0x352d32, grain: 0x7d6151,
  cap: 0xa78664, edge: 0xc7ab87, iron: 0x343b4b,
} as const;
const HARBOR_STYLE: Omit<HarborMaterialStyle, 'seed'> = {
  palette: {
    waterTop: 0x343952, waterDeep: 0x161c30, waterLight: 0x8996b5,
    wood: 0x685047, woodShade: 0x382e35, woodEdge: 0xb29473,
    stone: QUAY.face, stoneEdge: QUAY.cap, iron: 0x343948,
    rope: 0x9d8e79, amber: 0xc79c60, hull: 0x5b4851, cabin: 0x716373,
  },
  dressing: {
    deckHeight: 28, abutmentWidth: 60, pileOffsets: [90, 250, 420, 600, 790],
    reflectionCount: 24, lampOffset: 590, ferry: { x: 650, y: 40, width: 190, height: 90 },
  },
};

const SUPPORTED_ROOFS = new Set([
  'west_gate_canopy', 'inn_roof', 'council_roof',
  'trainer_hall_roof', 'dock_loft', 'east_watch',
]);

/** Town-only static drawing. Never changes geometry, creates objects, or retains a timer. */
export function drawTidewendTownMaterial(
  graphics: TownMaterialGraphics,
  platform: PlatformAccentBounds,
  isLedge: boolean,
  groundY: number,
): void {
  const { x, y, width, height } = platform;
  if (!validTownSurface(platform)) return;
  const seed = hashSeed(`${platform.id ?? ''}:${x}:${y}:${width}`);
  if (isLedge) drawTownTimber(graphics, platform, groundY, seed, TIMBER, SUPPORTED_ROOFS.has(platform.id ?? '') ? 'full' : 'braces');
  else if (platform.id === 'dock_floor' && x === 3500 && y === 1000 && width === 900 && height === 400) {
    drawHarborMaterial(graphics, platform, { ...HARBOR_STYLE, seed });
  }
  else drawTownQuay(graphics, platform, seed, QUAY, platform.id === 'dock_floor' ? { face: TIMBER.cap, edge: TIMBER.edge } : undefined);
}
